export const FORM_COMPLETE_ID = {
  'ce94fc77-e647-438b-b56f-d9f43597cb34': 'XYp06emgQzGT1RSAgaeU',
  '20811bff-320d-4ff3-affc-4888eb74cd5': 'fHzO0ZM3bKHjoByUUFeS',
  '98017dc8-b582-403b-a53a-68fc79c36546': '1fDUof7UK2akvCBkwNRs',
  '894f2a5e-7ef3-4001-a582-91ed296e0b4b': 'CXnYi3XQzzUShOgENyyw',
  'cfa8ac7e-4222-4a49-ba1a-2d0728a8b002': 'BwKqVlQ8MzQND85BOUUB',
  '3f082af9-5ce9-42df-9c5f-f0314a9297ca': '1BsF0TQ3217Mx3GYIx0K',
  '34345249-5e89-469d-8133-b00de7367949': 'MgYuQWo3txhCXBQ99kQY',
  '1d163103-bd52-43cb-8fe1-8da65276d3db': 'xV9AVMNsW3VsEZDc8Kiz',
  '7fe57779-e23b-474c-a54b-379813d699c4': 'r914OjnQR1paUdpxz8ul',
  '331fba43-23cb-4b62-81fc-c030fd137c92': 'n8b6h0P9AYkgDMRwCJ1Y'
}